import {
  FETCH_IWO_STATUS_REQUEST,
  FETCH_IWO_STATUS_SUCCESS,
  FETCH_IWO_STATUS_FAILURE,
  UPDATE_IWO_STATUS_REQUEST,
  UPDATE_IWO_STATUS_SUCCESS,
  UPDATE_IWO_STATUS_FAILURE,
} from "../constants/IwoStatusConstants";

import IwoStatusService from "../service/IwoStatusService";

export const fetchIwoStatus = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_IWO_STATUS_REQUEST });

    const data = await IwoStatusService.getIwoStatus(serviceNo);

    dispatch({
      type: FETCH_IWO_STATUS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: FETCH_IWO_STATUS_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch IWO status",
    });

    return [];
  }
};

export const updateIwoStatus =
  (iwoNo, status, serviceNo, completedDate) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_IWO_STATUS_REQUEST, payload: iwoNo });

      const response = await IwoStatusService.updateIwoStatus(
        iwoNo,
        status,
        completedDate,
        serviceNo
      );

      if (response?.StatusCode !== 200) {
        dispatch({
          type: UPDATE_IWO_STATUS_FAILURE,
          payload: response?.Result || "Failed to update IWO status",
        });

        return { success: false, message: response?.Result || "Update failed" };
      }

      dispatch({
        type: UPDATE_IWO_STATUS_SUCCESS,
        payload: { iwoNo, status, message: response?.Result },
      });

      // reload the list so the screen shows the saved value
      if (serviceNo) {
        dispatch(fetchIwoStatus(serviceNo));
      }

      return { success: true, message: response?.Result || "Updated" };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to update IWO status";

      dispatch({
        type: UPDATE_IWO_STATUS_FAILURE,
        payload: message,
      });

      return { success: false, message };
    }
  };